import { useEffect } from 'react';
import wowsEntities from '@wg/wows-entities';
import { WarmingUpCollections } from '@wg/wows-entities/const';
import { TooltipProvider } from '@wg/wows-react-uikit';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import * as Redux from 'redux';
import { applyMiddleware, createStore } from 'redux';
import { createLogger } from 'redux-logger';
import thunk from 'redux-thunk';

import ContainerApp from './Containers/ContainerApp';
import { settings } from './helpers/utils';
import reducer from './Reducers';

import './styles/global.scss';
import '@wg/wows-css-uikit/index.css';
import '@wg/wows-entities/index.css';
import '@wg/wows-common-footer/style.css';

const middleware: Redux.Middleware[] = [thunk];

if (process.env.NODE_ENV !== 'production') {
    middleware.push(createLogger());
}

export const store = createStore(reducer, applyMiddleware(...middleware));

const App = () => {
    useEffect(() => {
        wowsEntities
            .init({
                vortexBaseUrl: window.catalogue.urls.vortex,
                languageCode: settings.languageCode,
            })
            .then(() => {
                wowsEntities.warmingUp([WarmingUpCollections.rarity, WarmingUpCollections.vehicles, WarmingUpCollections.items]);
            });
    }, []);

    return (
        <Provider store={store}>
            <BrowserRouter>
                <TooltipProvider>
                    <ContainerApp />
                </TooltipProvider>
            </BrowserRouter>
        </Provider>
    );
};

export default App;
